import clipboard from './module/clipboard'

//定义一个名为install的vue常量函数，接收一个参数Vue，Vue参数表示Vue构造函数本身，当通过Vue.use调用
//install函数时，Vue会将自身作为参数传递给install函数，Vue可以访问所有全局Api
const install = function (Vue) {
    Vue.directive('clipboard', clipboard)//用于注册自定义指令的全局api，被注册的指令可以通过v-xxx使用
}

if (window.Vue) {
    window['clipboard'] = clipboard
    Vue.use(install); // eslint-disable-line
}

//将定义的install函数导出，供其他模块导入和使用
export default install
